<template>
  <div class="combination-list">
    <el-tabs v-model="activeName" type="card" @tab-click="paneClick">
      <el-tab-pane v-for="item in comList" :key="item.name" :label="item.title" :name="item.name">
        <div style="border: 1px solid #e4e7ed; border-top: none; padding: 10px; border-radius: 0 0 6px 6px">
          <component :is="item.name" :name="item.name" :ref="item.name"/>
        </div>
      </el-tab-pane>
    </el-tabs>
    <CombinDetail></CombinDetail>
  </div>
</template>
<script>
import CombinList from "./components/combinList";
import TaskList from "./components/taskList";
import PickList from "./components/pickList";
import WaitInspect from "./components/waitInspect";
import WaitMove from "./components/waitMove";
import CombinDetail from "./components/combinDetail"
export default {
  name: "combinationList",
  components: {
    CombinList,
    WaitMove,
    WaitInspect,
    TaskList,
    CombinDetail,
    PickList
  },
  data() {
    return {
      activeName: CombinList.name,
    };
  },
  methods: {
    handleClick() {},
    paneClick(tab, event){
      this.$refs[this.comList[tab.index].name][0].getList();
    }
  },
  computed: {
    comList: function () {
      return [CombinList,WaitInspect , PickList,WaitMove, TaskList];
    },
  },
  mounted() {
    this.$bus.$on("combinDetailClick", (record) => {
      console.log('',record);
    });
  },
};
</script>
<style lang="less" scoped>
.combination-list {
  padding: 0 10px;
}
::v-deep .el-tabs__header {
  margin-bottom: 0px !important;
}
::v-deep .el-form--inline .el-form-item{
  margin-bottom: 10px !important;
}
</style>